import Vue from 'vue'

const endPoint = process.env.VUE_APP_API_BASE_URL
const endPointV2 = process.env.VUE_APP_API_BASE_URL_V2
const endPointV3 = process.env.VUE_APP_API_BASE_URL_V3

// app log
export const appLog = `${endPoint}/applicationLog`

// app currency
export const currencies = `${endPoint}/getCurrencies`

// device token for notification
export const deviceToken = `${endPoint}/user/device-token`

// trips
export const homeTrips = `${endPoint}/trips-in-home/8`
export const trips = `${endPoint}/trips`
export const bookTrip = `${endPointV2}/trips/request-to-book`
export const allCities = `${endPointV2}/tours/list-city`
// offices
export const offices = `${endPoint}/offices/list`
// airlines
export const getAirlines = (term) => `${endPointV2}/flights/airlines/autocomplete?term=${term}`
export const getAirports = (term) => `${endPoint}/airport/autocomplete?term=${term}`
export const searchFlights = (term) => `${endPoint}/flights/search?${term}`
export const getFlight = (id, search, relatedFlightId) => {
  if (relatedFlightId) return `${endPoint}/flights?flight_id=${id}&search_id=${search}&related_flight_id=${relatedFlightId}`
  else return `${endPoint}/flights?flight_id=${id}&search_id=${search}`
}
export const checkFlight = `${endPoint}/flightAvailability`
export const getFlightPromotions = `${endPoint}/flights/promotions`
export const createPNR = `${endPoint}/pnr/create`
export const showPNR = (pnr) => `${endPoint}/pnr/${pnr}`
export const bookFlightByMail = `${endPointV2}/flights/send-special-offer-request-mail`

// user data
export const register = `${endPointV3}/auth/register`
export const profile = `${endPoint}/user/profile`
export const userBookings = `${endPoint}/user/bookings`
export const userUpdate = `${endPoint}/user/update`
export const updateNotification = `${endPoint}/user/updateNotification`
export const login = `${endPointV3}/auth/login`
export const logout = `${endPointV3}/auth/logout`
export const collectPoints = `${endPoint}/user/collect-points-history`
export const redeem = `${endPoint}/user/redeem-points-history`
export const cancelFlight = `${endPoint}/user/bookings/cancel-flight`

// auth
export const verify = `${endPointV3}/auth/email/verify`
export const resend = `${endPointV3}/auth/email/resend`
export const resetPasswordCode = `${endPointV3}/auth/reset-password-code`
export const resetPassword = `${endPointV3}/auth/reset-password`
export const approveEmail = (token) => `${endPointV3}/auth/approve-user?token=${token}`
export const forceChangePassword = `${endPointV3}/auth/force-change-password`

// cities
export const getCities = (term) => `${endPointV2}/cities/autocomplete?term=${term}`
export const getCitiesByCode = (code) => `${endPointV2}/cities/autocomplete?code=${code}&term=''`
export const searchHotels = (term) => `${endPointV2}/hotels/search?${term}`
export const getHotel = (sessionId, hotelIndex, hotelCode) => `${endPointV2}/hotels/show?sessionId=${sessionId}&hotelIndex=${hotelIndex}&hotelCode=${hotelCode}`
export const hotelAvailability = (term) => `${endPointV2}/hotels/room/availability?${term}`
export const bookHotel = `${endPointV2}/hotels/book`
export const holdRooms = `${endPointV2}/hotels/hold-booking`

// cars
export const carsSearch = (term) => `${endPoint}/cars/search?${term}`
export const showCar = (term) => `${endPoint}/cars/show?${term}`
export const rentCar = `${endPoint}/cars/book`

// insurance
export const calculateInsurace = `${endPoint}/insurance/price-and-plan`

// headers
export function headers (token) {
  return { Authorization: 'Bearer ' + token, Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://reservation.adamtravel.com' }
}
export function headersNoAuth () {
  if (Vue.$cookies.isKey('userToken')) return { Authorization: 'Bearer ' + Vue.$cookies.get('userToken'), Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://reservation.adamtravel.com' }
  else return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://reservation.adamtravel.com' }
}
